import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import qs from 'qs';

import { TAG_TYPES } from './constants';

const restBaseQuery = fetchBaseQuery({
  baseUrl: '/api/survey-api/',
  //? handle array or object query params
  paramsSerializer: (params) => qs.stringify(params),
});

export const emptySurveyApi = createApi({
  reducerPath: 'surveyApi',
  baseQuery: restBaseQuery,
  tagTypes: Object.values(TAG_TYPES),
  endpoints: () => ({}),
});
